import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Drawer,
  MenuItem,
  Paper,
  TextField,
  Typography
} from '@material-ui/core';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import SearchButton from '../../components/atoms/SearchButton';
import { getAccounts } from '../../actions/Accounts';
import {
  GET_TICKET_REFUND_SUCCESS,
  REFUND_EXTRA_PAY_TICKET_BIZMESHI_SUCCESS,
  getTicketRefund,
  refundExtraPayTicketBizmeshi
} from '../../actions/Tickets';
import { getSystems } from '../../actions/Systems';
import ShashokuRefundExtraPaySearchTable from '../organisms/ShashokuRefundExtraPaySearchTable';
import ValidationText from '../../components/atoms/ValidationText';
import ConfirmDialog from '../../components/molecules/ConfirmDialog';

const styles = {
  root: {},
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  dFlex: {
    display: 'flex'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      systems: state.systems.list
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getSystems,
          getTicketRefund,
          refundExtraPayTicketBizmeshi
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('fromSystemId', 'setFromSystemId', null),
  withState('fromSystemIdError', 'setFromSystemIdError', ''),
  withState('userTicketId', 'setUserTicketId', ''),
  withState('userTicketIdError', 'setUserTicketIdError', ''),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('ticketInfo', 'setTicketInfo', []),
  withState('openConfirmDialog', 'setOpenConfirmDialog', false),
  withState('messageConfirmRefund', 'setMessageConfirmRefund', ''),
  withState('merchantPaymentId', 'setMerchantPaymentId', ''),
  withHandlers({
    checkSession: props => data => {
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.actions.getSystems();
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    classes,
    openDrawer,
    updateOpenDrawer,
    account,
    openProgress,
    updateOpenProgress,
    loading,
    updateLoading,
    resultMessage,
    setResultMessage,
    fromSystemId,
    setFromSystemId,
    fromSystemIdError,
    setFromSystemIdError,
    userTicketId,
    setUserTicketId,
    userTicketIdError,
    setUserTicketIdError,
    systems,
    errorMessage,
    setErrorMessage,
    ticketInfo,
    setTicketInfo,
    openConfirmDialog,
    setOpenConfirmDialog,
    messageConfirmRefund,
    setMessageConfirmRefund,
    merchantPaymentId,
    setMerchantPaymentId,
    checkSession
  }) => {
    const validFromSystemIdError = v => {
      if (!v) {
        setFromSystemIdError('必須項目です。');
        return 1;
      }
      setFromSystemIdError('');
      return 0;
    };

    const validUserTicketId = v => {
      const value = v.trim();
      if (value === '') {
        setUserTicketIdError('必須項目です。');
        return 1;
      }
      setUserTicketIdError('');
      return 0;
    };

    const getTicketRefundInfo = async () => {
      await actions
        .getTicketRefund({
          fromSystemId,
          userTicketId
        })
        .then(data => {
          checkSession(data);
          if (data.type === GET_TICKET_REFUND_SUCCESS) {
            setTicketInfo([data.payload]);
          } else {
            setTicketInfo([]);
            setErrorMessage('返金できるチケットがありません。 ');
          }
        });
    };

    const searchAction = async () => {
      const valid =
        validFromSystemIdError(fromSystemId) + validUserTicketId(userTicketId);
      if (!valid) {
        updateLoading(true);
        updateOpenProgress(true);
        await getTicketRefundInfo();
        updateLoading(false);
        updateOpenProgress(false);
      }
    };

    const handleConfirmRefund = (chargeAmount, merchantId) => {
      setMessageConfirmRefund(`${chargeAmount}円を返金しますか。`);
      setMerchantPaymentId(merchantId);
      setOpenConfirmDialog(true);
    };

    const handleRefund = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      setOpenConfirmDialog(false);
      const response = await actions
        .refundExtraPayTicketBizmeshi({
          fromSystemId,
          merchantPaymentId
        })
        .then(data => checkSession(data));
      if (response.type === REFUND_EXTRA_PAY_TICKET_BIZMESHI_SUCCESS) {
        setTicketInfo([]);
        setUserTicketId('');
        setFromSystemId(null);
        setResultMessage('返金が完了しました。');
      } else {
        setErrorMessage('エラーが発生しました！');
        updateOpenProgress(false);
      }
      updateLoading(false);
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const progressOkAction = async () => {
      updateOpenProgress(false);
      updateLoading(true);
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            社食ごちめしのチケット返金
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div className={classes.dFlex}>
              <div>
                <TextField
                  select
                  label="会社名"
                  className={classes.textField}
                  margin="normal"
                  value={fromSystemId}
                  onChange={e => {
                    setFromSystemId(e.target.value || '');
                  }}
                  InputLabelProps={{
                    shrink: fromSystemId
                  }}
                >
                  {systems.map(item => {
                    return (
                      <MenuItem
                        key={item.connectSystemId}
                        value={item.connectSystemId}
                      >
                        {item.connectSystemName}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <ValidationText message={fromSystemIdError} />
              </div>
              <div>
                <TextField
                  label="user_ticket_id"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={userTicketId}
                  onChange={e => {
                    setUserTicketId(e.target.value.trim());
                  }}
                />
                <ValidationText message={userTicketIdError} />
              </div>
            </div>
            <div className={classes.buttonGroupLeft}>
              <SearchButton onClickAction={searchAction} />
            </div>
          </div>
          <ShashokuRefundExtraPaySearchTable
            progress={progress}
            setResultMessage={setResultMessage}
            updateOpenProgress={updateOpenProgress}
            updateLoading={updateLoading}
            ticketInfo={ticketInfo}
            handleConfirmRefund={handleConfirmRefund}
          />
        </Paper>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />

        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />

        <ConfirmDialog
          openConfirm={openConfirmDialog}
          updateOpenConfirm={setOpenConfirmDialog}
          message={messageConfirmRefund}
          okAction={() => handleRefund()}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
